import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { dataFieldsService, FieldType } from 'src/services';

export const createMerchandisingRuleContainerActions = {
  navigateTo: createAction<{ navigateTo: string }>('CreateMerchandisingRuleContainer/NavigateTo'),
  getDataFields: createAsyncThunk(
    'CreateMerchandisingRuleContainer/GetDataFields',
    async (
      { shopId, fieldType }: { shopId: number; fieldType?: FieldType },
      { rejectWithValue }
    ) => {
      try {
        const dataFields = await dataFieldsService.getDataFields({ shopId, fieldType });
        return { dataFields };
      } catch (error) {
        return rejectWithValue({ error });
      }
    }
  ),
};
